/**
 * Fallback no cliente para registros de log antigos (sem `descricao_do_tipo_de_acao` gravada).
 * Alinhar com `server/src/constants/activity-log-narratives.ts`.
 */
export const ACTION_TYPE_NARRATIVES = {
  edital_created:
    "Foi cadastrado um novo edital (processo licitatório) na empresa. O registro passa a constar no sistema para acompanhamento, elaboração de proposta e gestão no quadro Kanban, conforme o fluxo da equipe.",
  edital_updated:
    "Os dados de um edital já existente foram alterados — por exemplo dados gerais, checklist, itens, documentação exigida, capacidade técnica, sala de guerra ou campos extraídos. A linha “Descrição” do log identifica qual processo foi afetado.",
  edital_deleted:
    "Um edital foi removido do sistema. Ele deixa de aparecer nas listagens habituais; a exclusão é em geral definitiva.",
  edital_status_changed:
    "A situação ou etapa do edital foi alterada (status de processo, negociação ou aprovação), refletindo mudança no andamento licitatório.",
  contrato_created:
    "Foi criado um novo contrato (número, órgão contratante, objeto, valores, vigência ou anexos conforme preenchidos). Passa a integrar o módulo de contratos para gestão e alertas.",
  contrato_updated:
    "Um contrato existente foi atualizado: podem ter sido alterados dados cadastrais, valores, vigência, forma de pagamento, anexos ou demais campos do cadastro.",
  contrato_deleted:
    "Um contrato foi excluído do sistema. O registro desta operação permanece no log.",
  contrato_status_changed:
    "O status do contrato foi alterado, indicando mudança na situação formal da contratação.",
  proposta_created:
    "Foi registrada uma nova proposta (comercial/técnica), em geral vinculada a um edital ou oportunidade, passando a constar no módulo de propostas.",
  proposta_updated:
    "Dados de uma proposta existente foram modificados (identificação, valores, prazos, descrição ou vínculos).",
  proposta_deleted:
    "Uma proposta foi excluída do cadastro.",
  proposta_email_sent:
    "Foi solicitado o envio da proposta por e-mail com PDF anexado. O registro indica destinatário, arquivo e se o SMTP concluiu o disparo.",
  proposta_email_resent:
    "Foi solicitado o reenvio da proposta por e-mail com PDF anexado. O registro indica destinatário, arquivo e se o SMTP concluiu o novo disparo.",
  event_created:
    "Foi criado um evento ou compromisso na agenda (título, datas, responsável opcional e vínculo a edital quando aplicável).",
  event_updated:
    "Um evento da agenda foi alterado (datas, título, descrição, responsável ou vínculo a edital).",
  event_deleted:
    "Um evento foi removido da agenda.",
  atestado_created:
    "Foi cadastrado um novo atestado técnico, utilizado para comprovação de capacidade e análise de compatibilidade com editais.",
  atestado_updated:
    "Um atestado técnico existente foi atualizado (instituição, vigência, competências, resumo ou anexo).",
  atestado_deleted:
    "Um atestado técnico foi excluído.",
  login_success:
    "O usuário autenticou-se com sucesso nesta empresa e obteve sessão válida para acessar os módulos permitidos pelo seu perfil e plano.",
  login_failed:
    "Tentativa de autenticação que não foi bem-sucedida (credenciais inválidas ou outro bloqueio). O registro ajuda a auditar acessos indevidos.",
  kanban_column_moved:
    "O edital foi movido de uma coluna para outra no quadro Kanban, indicando mudança de etapa no fluxo visual de trabalho. Os dados complementares trazem os identificadores da coluna anterior e da nova, quando disponíveis.",
  configuracao_empresa_updated:
    "Foram salvos dados institucionais da empresa utilizados em documentos e cadastro: identificação, endereço, contatos, dados bancários, sócio, textos de cabeçalho/rodapé e imagens associadas (marca d’água, assinatura, etc.).",
  empresa_data_export_full:
    "Foi gerado e baixado um pacote ZIP com exportação estruturada dos dados da empresa na plataforma (portabilidade), incluindo cadastros, módulos de negócio, anexos armazenados e registros de auditoria pertinentes, com omissão de segredos de autenticação.",
  assina_envelope_created:
    "Foi criado um envelope no módulo Assina (assinatura eletrônica), para envio de documentos a signatários externos.",
  assina_envelope_sent:
    "Um envelope Assina foi enviado: os signatários receberam convite por e-mail (quando o SMTP está configurado) para assinar com o fluxo definido.",
  assina_invites_resent:
    "Foram reenviados convites por e-mail aos signatários pendentes de um envelope Assina (novos links de assinatura gerados).",
  assina_envelope_cancelled:
    "Um envelope Assina foi cancelado antes da conclusão ou após rejeição; o processo de assinatura associado deixa de aceitar novas assinaturas.",
  documento_trashed:
    "Um documento do cadastro foi movido para a lixeira: deixa de aparecer nas listagens da empresa e pode ser recuperado pelo super administrador dentro do prazo de retenção.",
  documento_restored:
    "Um documento que estava na lixeira foi restaurado e voltou a ficar visível no módulo de documentos da empresa.",
  licoes_aprendida_trashed:
    "Um registro de lições aprendidas foi movido para a lixeira e pode ser recuperado pelo super administrador dentro do prazo de retenção.",
  licoes_aprendida_restored:
    "Um registro de lições aprendidas foi restaurado a partir da lixeira e voltou à listagem normal.",
  edital_trashed:
    "Um edital (licitação) foi movido para a lixeira: deixa de aparecer nas listagens da empresa e pode ser recuperado pelo super administrador dentro do prazo de retenção.",
  edital_restored:
    "Um edital que estava na lixeira foi restaurado e voltou a ficar visível no módulo de licitações da empresa.",
  proposta_trashed:
    "Uma proposta foi movida para a lixeira e pode ser recuperada pelo super administrador dentro do prazo de retenção.",
  proposta_restored:
    "Uma proposta foi restaurada a partir da lixeira e voltou à listagem normal.",
  contrato_trashed:
    "Um contrato foi movido para a lixeira e pode ser recuperado pelo super administrador dentro do prazo de retenção.",
  contrato_restored:
    "Um contrato foi restaurado a partir da lixeira e voltou à listagem normal do módulo de contratos.",
  atestado_tecnico_trashed:
    "Um atestado técnico foi movido para a lixeira e pode ser recuperado pelo super administrador dentro do prazo de retenção.",
  atestado_tecnico_restored:
    "Um atestado técnico foi restaurado a partir da lixeira e voltou à listagem normal.",
  manifesto_manifestacao_created:
    "Foi criada uma manifestação no módulo Manifesto (impugnação, esclarecimento, diligência, intenção de recurso ou contrarrazão), vinculada a um edital, para elaboração e acompanhamento da peça.",
  manifesto_manifestacao_updated:
    "Os dados de uma manifestação Manifesto foram alterados (título, observações ou dados de protocolo).",
  manifesto_manifestacao_status_changed:
    "O status de workflow de uma manifestação Manifesto foi alterado (ex.: envio para revisão, aprovação ou protocolo).",
  manifesto_peca_versao_created:
    "Foi registrada uma nova versão do texto da peça no Manifesto (inclusão manual ou rascunho gerado por IA), mantendo histórico versionado.",
  manifesto_prazo_created:
    "Foi cadastrado um prazo manual associado a uma manifestação Manifesto (lembrete de data limite).",
  manifesto_prazo_updated:
    "Um prazo do Manifesto foi alterado (rótulo, datas ou notas).",
  manifesto_prazo_deleted:
    "Um prazo do Manifesto foi excluído do registro da manifestação.",
  manifesto_pdf_exported:
    "Foi gerado e baixado o PDF timbrado da manifestação no Manifesto (texto da última versão salva no servidor).",
  manifesto_pdf_preview:
    "Foi gerado o PDF timbrado em modo pré-visualização no Manifesto (texto do rascunho enviado, sem gravar nova versão).",
  _default:
    "Ação registrada pela aplicação. Use a descrição do registro, a entidade e os dados complementares abaixo para interpretar o contexto.",
};

export function narrativeForActionType(actionType) {
  if (!actionType || typeof actionType !== "string") return ACTION_TYPE_NARRATIVES._default;
  return ACTION_TYPE_NARRATIVES[actionType] ?? ACTION_TYPE_NARRATIVES._default;
}
